import { ComponentProps, FC } from 'react';

const VeniSVG: FC<ComponentProps<'svg'>> = (props) => {
  return (
    <svg
      width="56.155"
      height="19.718"
      viewBox="0 0.879 56.155 19.718"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M50.0599 20.5926H47.3779V8.73677C47.3779 5.88256 45.0555 3.56046 42.2009 3.56046C39.3463 3.56046 37.0239 5.88256 37.0239 8.73677V20.5958H34.3418V8.73677C34.3418 4.40392 37.8673 0.878906 42.2007 0.878906C46.5341 0.878906 50.0596 4.40392 50.0596 8.73677V20.5926H50.0599Z" />
      <path d="M0.000179352 1.32324H3.02222L8.68511 17.0031H8.73954L14.6201 1.32324H17.4789L9.88293 20.5965H7.43268L0.000179352 1.32324Z" />
      <path d="M18.9258 1.3236H31.368V3.77353H21.5395V9.5172H30.6874V11.9671H21.5395V18.1466H31.8581V20.5965H18.926V1.32324L18.9258 1.3236Z" />
      <path d="M53.498 1.34082H56.1543V20.5965H53.498V1.34082Z" />
    </svg>
  );
};

export default VeniSVG;
